import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainRenameMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  newName: Types.Scalars['String']['input'];
}>;


export type DomainRenameMutation = { __typename?: 'Mutation', domainRename: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } };


export const DomainRenameDocument = gql`
    mutation DomainRename($domainId: Int!, $newName: String!) {
  domainRename(domainId: $domainId, newName: $newName) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type DomainRenameMutationFn = Apollo.MutationFunction<DomainRenameMutation, DomainRenameMutationVariables>;

/**
 * __useDomainRenameMutation__
 *
 * To run a mutation, you first call `useDomainRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainRenameMutation, { data, loading, error }] = useDomainRenameMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useDomainRenameMutation(baseOptions?: Apollo.MutationHookOptions<DomainRenameMutation, DomainRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainRenameMutation, DomainRenameMutationVariables>(DomainRenameDocument, options);
      }
export type DomainRenameMutationHookResult = ReturnType<typeof useDomainRenameMutation>;
export type DomainRenameMutationResult = Apollo.MutationResult<DomainRenameMutation>;
export type DomainRenameMutationOptions = Apollo.BaseMutationOptions<DomainRenameMutation, DomainRenameMutationVariables>;